<template>
  <div class="nav">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name:"Nav",
  props:{
    data:{
      type:Array,
      default:()=>[]
    }
  },
  data(){
    return {

    }
  },
  
}
</script>
<style lang="less" scoped>
  @import url(../../common/css/variable.less);
  .nav{

  }
</style>



// WEBPACK FOOTER //
// src/components/Nav/Nav.vue